import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { Dropdown, Layout } from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'
import PageContent from '~/components/PageContent'
import { selectAuthUser } from '~/store/auth/selector'
import { useLogoutMutation } from '../mutations'
import SideBar from './SideBar'

const UserLayout = () => {
  const [collapsed, setCollapsed] = useState(false)
  const { mutate: logOut } = useLogoutMutation()
  const user = useSelector(selectAuthUser)

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <SideBar trigger={null} collapsed={collapsed} />
      <Layout className="site-layout">
        <Layout.Header
          className="site-layout-background flex items-center"
          style={{
            backgroundColor: '#fff',
            padding: 0,
            fontWeight: 'bold',
            fontSize: '16px'
          }}
        >
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: 'trigger',
            onClick: () => setCollapsed(!collapsed)
          })}

          <div className="ml-auto flex h-full">
            <Dropdown
              trigger={'click'}
              menu={{
                items: [
                  { label: 'Log Out', onClick: logOut, key: 'logout' }
                ]
              }}
            >
              <div className={'cursor-pointer mr-4 flex'}>
                <div className="items-end header-profile">
                  <span className="profile">{user?.name || null}</span>
                  <span className="profile">{user?.email || null}</span>
                </div>
              </div>
            </Dropdown>
          </div>
        </Layout.Header>
        <PageContent>
          <Outlet />
        </PageContent>
      </Layout>
    </Layout>
  )
}

export default UserLayout
